import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`health`, model)
    },
    async fetchById(id) {
        return await axios.get(`health/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`health?q=${query}&page=${page}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`health/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`health/${id}`)
    },
}
